var OompaLoompa = (function () {
    // FIXME: Request Injector once we move to Angular 4.2+, it'll allow easier refactors
    function OompaLoompa(cdr, willyWonka) {
        var _this = this;
        this.subscription = willyWonka.chocolate.subscribe(function () {
            if (_this.latestFlavor !== _this.flavor) {
                cdr.detectChanges();
            }
        });
    }
    OompaLoompa.prototype.ngAfterContentChecked = function () {
        this.latestFlavor = this.flavor;
    };
    OompaLoompa.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return OompaLoompa;
}());
export { OompaLoompa };
//# sourceMappingURL=oompa-loompa.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/utils/chocolate/oompa-loompa.js
// module id = 212
// module chunks = 4